<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-modulos-programas-universidades"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro } from '../utils/funciones';

export default {
  name: 'ListadoModulosProgramas',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'MÓDULO',
          field: 'modulo.nombre',
          minWidth: 800,
        },
        {
          headerName: 'DOCENTE',
          cellRenderer: (params) => {
            return params.data?.docente
              ? `${params.data.docente.numeroDocumento} - ${params.data.docente.nombres} ${
                  params.data.docente.primerApellido || ''
                } ${params.data.docente.segundoApellido || ''}`
              : '';
          },
          minWidth: 350,
        },
        {
          headerName: 'NÚMERO',
          field: 'numero',
          type: 'numericColumn',
          filter: false,
          minWidth: 80,
          maxWidth: 80,
        },
        {
          headerName: 'C. H. PRESENCIAL',
          field: 'cargaHorariaPresencial',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'C. H. NO PRESENCIAL',
          field: 'cargaHorariaNoPresencial',
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'FECHA INICIO',
          field: 'fechaInicio',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
        },
        {
          headerName: 'FECHA FIN',
          field: 'fechaFin',
          filter: false,
          minWidth: 110,
          maxWidth: 110,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-modulos-programas-universidades {
  height: calc(var(--vh, 1vh) * 100 - 33rem);
}
</style>
  